<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <div class="form-row">
    <label class="col-sm-9"
           for="istErfolgt">{{ 'COMMON_UI.FRAGEBOGEN.HANDELSREGISTEREINTRAG.ISTERFOLGT.TITEL' | translate }}</label>
    <div class="col-sm-3">
      <select class="form-control" formControlName="istErfolgt" id="istErfolgt" (change)="onSelectionChange()">
        <option [ngValue]="null"
                selected>{{ 'COMMON_UI.FRAGEBOGEN.HANDELSREGISTEREINTRAG.ISTERFOLGT.NULL' | translate }}</option>
        <option [ngValue]="true"
                selected>{{ 'COMMON_UI.FRAGEBOGEN.HANDELSREGISTEREINTRAG.ISTERFOLGT.JA' | translate }}</option>
        <option [ngValue]="false"
                selected>{{ 'COMMON_UI.FRAGEBOGEN.HANDELSREGISTEREINTRAG.ISTERFOLGT.NEIN' | translate }}</option>
      </select>
    </div>
  </div>

  <div *ngIf="data?.istErfolgt" class="form-row">
    <label class="col-sm-4 col-form-label" for="eingetragenAm">
      {{ 'COMMON_UI.FRAGEBOGEN.HANDELSREGISTEREINTRAG.EINGETRAGENAM' | translate }}
    </label>
    <div class="col-sm-8">
      <date-picker
              id="eingetragenAm"
              messagePath="eingetragenAm"
              formControlName="eingetragenAm"
              [isRequired]=true>
      </date-picker>
    </div>
  </div>

  <div *ngIf="!data.istErfolgt" class="form-row">
    <label class="col-sm-9"
           for="bereitsGestellt">{{ 'COMMON_UI.FRAGEBOGEN.HANDELSREGISTEREINTRAG.BEREITSGESTELLT.TITEL' | translate }}</label>
    <div class="col-sm-3">
      <select class="form-control" formControlName="bereitsGestellt" id="bereitsGestellt" utilsControlState  (change)="onSelectionChange()">
        <option [ngValue]="null"
                selected>{{ 'COMMON_UI.FRAGEBOGEN.HANDELSREGISTEREINTRAG.BEREITSGESTELLT.NULL' | translate }}</option>
        <option [ngValue]="true"
                selected>{{ 'COMMON_UI.FRAGEBOGEN.HANDELSREGISTEREINTRAG.BEREITSGESTELLT.JA' | translate }}</option>
      </select>
    </div>
  </div>

  <div *ngIf="data?.bereitsGestellt" class="form-row">
    <label class="col-sm-4 col-form-label" for="gestelltAm">
      {{ 'COMMON_UI.FRAGEBOGEN.HANDELSREGISTEREINTRAG.GESTELLTAM' | translate }}
    </label>
    <div class="col-sm-8">
      <date-picker
              id="gestelltAm"
              messagePath="gestelltAm"
              formControlName="gestelltAm"
              [isRequired]=true>
      </date-picker>
    </div>
  </div>

  <div *ngIf="data?.istErfolgt || data?.bereitsGestellt" class="form-row">
    <label class="col-sm-4 col-form-label" for="ortRegistergericht">
      {{ 'COMMON_UI.FRAGEBOGEN.HANDELSREGISTEREINTRAG.ORTREGISTERGERICHT' | translate }}
    </label>
    <div class="col-sm-8">
      <input class="form-control" datevMessagePath="ortRegistergericht{{objectId}}" formControlName="ortRegistergericht"
             id="ortRegistergericht" type="text" utilsCheckValidity
             utilsControlState utilsMarkRequired utilsValidationMessage/>
    </div>
  </div>

  <div *ngIf="data?.istErfolgt" class="form-row">
    <label class="col-sm-4 col-form-label" for="handelsregisterBezeichnung">
      {{ 'COMMON_UI.FRAGEBOGEN.HANDELSREGISTEREINTRAG.BEZEICHNUNG.TITEL' | translate }}
    </label>
    <div class="col-sm-8">
      <select class="form-control" datevMessagePath="handelsregisterBezeichnung{{objectId}}"
              formControlName="handelsregisterBezeichnung" id="handelsregisterBezeichnung"
              utilsCheckValidity utilsControlState utilsMarkRequired utilsValidationMessage>
        <option [ngValue]="null"
                disabled hidden
                selected>
          {{ 'COMMON_UI.FRAGEBOGEN.HANDELSREGISTEREINTRAG.BEZEICHNUNG.NULL' | translate }}
        </option>
        <option *ngFor="let value of enumKeys(handelsregisterBezeichnungEnum)"
                [ngValue]="handelsregisterBezeichnungEnum[value]">
          {{ 'COMMON_UI.FRAGEBOGEN.HANDELSREGISTEREINTRAG.BEZEICHNUNG.KEY_' + toTranslationKey(handelsregisterBezeichnungEnum[value]) | translate }}
        </option>
      </select>
    </div>
  </div>

  <div *ngIf="data?.istErfolgt" class="form-row">
    <label class="col-sm-4 col-form-label" for="handelsregisterNummer">
      {{ 'COMMON_UI.FRAGEBOGEN.HANDELSREGISTEREINTRAG.NUMMER' | translate }}
    </label>
    <div class="col-sm-8">
      <input class="form-control" datevMessagePath="handelsregisterNummer{{objectId}}" formControlName="handelsregisterNummer"
             id="handelsregisterNummer" type="text" utilsCheckValidity
             utilsControlState utilsMarkRequired utilsValidationMessage/>
    </div>
  </div>

  <div *ngIf="!data?.istErfolgt && !data?.bereitsGestellt" class="form-row">
    <label class="col-sm-9"
           for="istBeabsichtigt">{{ 'COMMON_UI.FRAGEBOGEN.HANDELSREGISTEREINTRAG.ISTBEABSICHTIGT.TITEL' | translate }}</label>
    <div class="col-sm-3">
      <select class="form-control" formControlName="istBeabsichtigt" id="istBeabsichtigt" utilsControlState>
        <option [ngValue]="null"
                selected>{{ 'COMMON_UI.FRAGEBOGEN.HANDELSREGISTEREINTRAG.ISTBEABSICHTIGT.NULL' | translate }}</option>
        <option [ngValue]="true"
                selected>{{ 'COMMON_UI.FRAGEBOGEN.HANDELSREGISTEREINTRAG.ISTBEABSICHTIGT.JA' | translate }}</option>
      </select>
    </div>
  </div>

</form>
